import { render, staticRenderFns } from "./ScreenTagSelect.vue?vue&type=template&id=70661890&"
import script from "./ScreenTagSelect.vue?vue&type=script&lang=js&"
export * from "./ScreenTagSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports